export const CARRIER_COLUMN_LIST = [
    'Status', 'ContractGSDB', 'Name', 'Street', 'Postcode', 'City', 'Country',
    'IMCSSiteCode','VATCode', 'CreatedBy', 'Created(Date/Time)',  'Modified(Date/Time)'
]

export const CARRIER_DISPLAY_AGREEMENT_COLUMNS = [
    {name:'Selected', label:"Selected", selected: false, ScreenColumnID: 0, ScreenID: 0, orderId:0},
    { name: "Status", label: "Status", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:1 },
    { name: "ContractGSDB", label: "Contract GSDB", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:2 },
    { name: "Name", label: "Name", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:3 },
    { name: "Street", label: "Street", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:4 },
    { name: "Postcode", label: "Postcode", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:5 },
    { name: "City", label: "City", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:6 },
    { name: "CountryName", label: "Country", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:7 },
    { name: "IMCSSiteCode", label: "GSDB Site Code", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:8 },
    { name: "CreatedOn", label: "Created (Date/Time)", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:9 },
    { name: "ModifiedOn", label: "Modified (Date/Time)", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:10 },
    {name:'action', label:"action", selected: false, ScreenColumnID: 0, ScreenID: 0, orderId:0},
    
];